import type { Database } from 'sql.js';
import { queryOne, rowFirstKeyColumn as col } from './sqljsSqlitePrimitives.ts';

/**
 * Returns the active voucher caption (`bonos.nombre`) for a row id, or `null` when missing.
 */
export function lookupBonoNombreById(db: Database, bonoId: number | null | undefined): string | null {
  if (bonoId == null || !Number.isFinite(bonoId) || bonoId <= 0) return null;
  if (
    queryOne(db, `SELECT 1 FROM sqlite_master WHERE type='table' AND name='bonos'`, []) == null
  ) {
    return null;
  }
  const row = queryOne(db, `SELECT nombre FROM bonos WHERE id = ? AND estado = 1`, [bonoId]);
  if (!row) return null;
  const n = String(col(row, 'nombre', 'NOMBRE') ?? '').trim();
  return n.length > 0 ? n : null;
}
